import { useCallback, useMemo } from 'react'
import api from '../../lib/commons/api'
import {
  BatchUpdateRequest,
  UserExperimentRepository,
  UserExperimentSetting,
} from '../../applications/ports/userExperimentRepository'

export const useUserExperimentRepository = (): UserExperimentRepository => {
  const fetchAll = useCallback(async (): Promise<UserExperimentSetting[]> => {
    const response = await api.functional.request(
      'GET',
      '/api/v1/user-experiments',
      {},
      true
    )
    return response.json ?? []
  }, [])

  const update = useCallback(
    async (
      experimentId: string,
      useNew: boolean
    ): Promise<{ success: boolean }> => {
      await api.functional.request(
        'PUT',
        `/api/v1/user-experiments/${experimentId}`,
        { useNew },
        true
      )
      return { success: true }
    },
    []
  )

  const batchUpdate = useCallback(
    async (settings: BatchUpdateRequest[]): Promise<{ success: boolean }> => {
      await api.functional.request(
        'PUT',
        '/api/v1/user-experiments',
        { settings },
        true
      )
      return { success: true }
    },
    []
  )

  return useMemo(
    () => ({ fetchAll, update, batchUpdate }),
    [fetchAll, update, batchUpdate]
  )
}
